module.exports = __webpack_public_path__ + "img/schaduwgedrag.3c18d06b.png";